class EnrichPawsCookieBanner extends HTMLElement {
  connectedCallback() {
    this.acceptButton = this.querySelector('[data-consent="accept"]');
    this.declineButton = this.querySelector('[data-consent="decline"]');
    this.acceptButton?.addEventListener('click', () => this.saveConsent(true));
    this.declineButton?.addEventListener('click', () => this.saveConsent(false));
    this.loadPrivacyApi();
  }

  loadPrivacyApi() {
    if (!window.Shopify?.loadFeatures) return;
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => {
        if (error || !window.Shopify.customerPrivacy) return;
        if (window.Shopify.customerPrivacy.shouldShowBanner()) {
          this.dataset.visible = 'true';
        }
      }
    );
  }

  saveConsent(allowed) {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;
    privacy.setTrackingConsent(
      {
        analytics: allowed,
        marketing: allowed,
        preferences: allowed
      },
      () => {
        this.dataset.visible = 'false';
      }
    );
  }
}

if (!customElements.get('enrichpaws-cookie-banner')) {
  customElements.define('enrichpaws-cookie-banner', EnrichPawsCookieBanner);
}
